<template>
  <DashboardBottomCardContent
    :callToActionButtonText="$t('L_create_your_plan')"
    @callToActionCallback="updateDebts"
  >
    <template #icon>
      <v-img
        :src="debtCalculatorIcon"
        alt="debtcalculator-icon"
        width="65"
        max-width="65"
        role="presentation"
        class="ma-0"
      />
    </template>
    <template #content>
      <h4 role="heading" aria-level="3" class="ml-6">
        <span class="text-h4 d-block font-weight-bold">{{
          $t('L_how_soon_could_you_be_debtfree')
        }}</span>
        <span class="d-block font-weight-regular">{{ $t('L_use_debt_stacking_to_help') }}</span>
      </h4>
    </template>
  </DashboardBottomCardContent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import debtCalculatorIcon from '../assets/debt-calculator.svg';
import DashboardBottomCardContent from '../../DashboardBottomCardContent.vue';
import { RouteNames } from '@/router/routeNames';
import { $t } from '@/i18n/i18n.ts';
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';

export default defineComponent({
  name: 'DebtSolutionsV03BottomSingle',
  components: { DashboardBottomCardContent },
  data() {
    return { debtCalculatorIcon };
  },
  methods: {
    $t,
    async updateDebts(this: { $route: RouteLocationNormalizedLoaded; $router: Router }) {
      const route = this.$route;
      const router = this.$router;

      if (route.path !== '/debtsolutions/mydebt') {
        await router.push({ name: RouteNames.MY_DEBT });
      }
    },
  },
});
</script>
